import script from "./step15OfferSLA.vue?vue&type=script&setup=true&lang=ts"
export * from "./step15OfferSLA.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__